export const WHATS_NEW_VERSION = '0.0.7';